/*
 各种常量 字典
* */

const state = {
  //companyPlugin -- 企业插件对应路由地址 路由地址由前端配置 后台只返回的插件权限
  companyPlugin: {
    '回收站': 'recycleCustom',
  },

  //RoleIconList  -- 路由对应 图标
  RoleIconList: {
    'dscj': 'ios-paw-outline',
    'dssx': 'ios-color-wand-outline',
    'dsyy': 'ios-photos-outline',
    'dskf': 'ios-photos-outline',
    'zjsyy': 'ios-rose-outline',
    'zjssx': 'ios-color-wand-outline',
    'msjd': 'ios-home-outline',
    'cwzx': 'ios-calculator-outline',
    'report': 'ios-pulse-strong',
    'glzx': 'ios-gear-outline',
    'mdrygl': 'ios-gear-outline',
    'zjscj': 'ios-briefcase-outline',
    'tjzx': 'ios-analytics-outline'
  },

  // condition --客资条件
  condition: {
    //receiveList-- 领取类型下拉
    receiveList: [
      {
        value: '1',
        label: '录入时间'
      },
      {
        value: '2',
        label: '领取时间'
      },
       {value: '3', label: '提报进店时间'},
       {value: '4', label: '实际进店时间'},
      {
        value: '5',
        label: '订单时间'
      },
      {value: '6', label: '跟踪时间'},
      {
        value: '7',
        label: '最后操作时间'
      },
      { value: '8',
        label: '邀约提报时间'},
      {
        value: '9',
        label: '邀约进店时间'
      }
    ],

    //SearchDateList -- 搜索日期下拉
    SearchDateList: [
      {
        value: 'today',
        label: '今天'
      },
      {
        value: 'yesterday',
        label: '昨日'
      },
      {
        value: 'thisWeek',
        label: '本周'
      },
      {
        value: 'lastWeek',
        label: '上周'
      },
      {
        value: 'thisMonth',
        label: '本月'
      },
      {
        value: 'lastMonth',
        label: '上月'
      },
      {
        value: 'thisQuarter',
        label: '本季度'
      },
      {
        value: 'lastQuarter',
        label: '上季度'
      }
    ],

    //selectKz -- 客资类型
    selectKz: [
      {
        label: '所有客资',
        value: '0'
      },
      {
        label: '电话客资',
        value: '1'
      },
      {
        label: '微信客资',
        value: '2'
      },
      {
        label: 'QQ客资',
        value: '3'
      },
      {
        label: '有电话有微信',
        value: '4'
      },
      {
        label: '无电话',
        value: '5'
      },
      {
        label: '无微信',
        value: '6'
      },
      {
        label: '无电话无微信',
        value: '7'
      },
      {
        label: '只有电话',
        value: '8'
      },
      {
        label: '只有微信',
        value: '10'
      },
      {
        label: '双客资',
        value: '11'
      },
      {
        label: '有旺旺',
        value: '12'
      }
    ]
  },

  //entry  -- 婚纱对应图标
  wedding: {
    '婚纱照': 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_hunshazhao.png',
    '写真': 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_xiezhen.png',
    '全家福': 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_quanjiafu.png',
    '宝宝照': 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_ertong.png',
    '孕妇照': 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_yunfuzhao.png',
    '亲子照': 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_qinzi.png',
    '成长照': 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_chengzhang.png',
    '外景照': 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_waijing.png',
    '礼服照': 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_lifuzhao.png',
    '纪念照': 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_jinianzhao.png',
    '形象照': 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_xingxiangzhao.png',
    '闺蜜照': 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_guimizhao.png',
    '母女照': 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_munvzhao.png',
    '婚庆照': 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_hunqingzhao.png',
    '证件照': 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_zhengjianzhao.png',
    '婴儿照': 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_yingerzhao.png',
    '儿童照': 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_ertongzhao.png',
    '集体照': 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_jitizhao.png',
    '毕业照': 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_biyezhao.png',
    '宠物照': 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_chongwuzhao.png',
    '芳华照': 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_fanghuazhao.png',
    '补拍': 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_bupaizhao.png',
    '其他': 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_other.png'
  },

  //custormIcons  -- 微信 手机 旺旺图片
  custormIcons: {
    phoneImg: 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/tel_green.png',
    wxImg: 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/wechat_offline.png',
    wwImg: 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/wangwang_offline.png',
    qqImg: 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/qq_offline.png',
    otherImg: 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/type_hunshazhao.png',
    qrCode: 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/qr_code.png',
  },

  //性别图片
  sexImg: ['http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/sex_null.png', 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/sex_male.png', 'http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/sex_female.png'],

  //搜索更多选项
  moreOption: {
    type: [
      {
        value: '1',
        label: '更多选项'
      },
      {
        value: 'info.STATUSID',
        label: '客资状态'
      },
      {
        value: 'det.YXLEVEL',
        label: '意向等级'
      },
      {
        value: 'info.TYPEID',
        label: '拍摄类型'
      },
      {
        value: 'info.ID',
        label: '编号'
      },
      {
        value: 'det.HTNUM',
        label: '合同编号'
      },
      {
        value: 'det.AMOUNT',
        label: '订单金额'
      },
      {
        value: 'det.COLLECTORNAME',
        label: '推广姓名'
      },
      {
        value: 'det.APPOINTNAME',
        label: '客服姓名'
      },
      {
        value: 'det.RECEPTORNAME',
        label: '门市姓名'
      },
      {
        value: 'det.OLDKZNAME',
        label: '老客姓名'
      },
      {
        value: 'info.OLDKZPHONE',
        label: '老客电话'
      },
      {
        value: 'det.ZXSTYLE',
        label: '咨询方式'
      },
      {
        value: 'det.YSRANGE',
        label: '预算范围'
      },
      {
        value: 'det.ADID',
        label: '广告ID'
      },
      {
        value: 'det.ADDRESS',
        label: '地址'
      },
      {
        value: 'det.KEYWORD',
        label: '关键字'
      },
      {
        value: 'info.SEX',
        label: '性别'
      },
      {
        value: 'info.WEFLAG',
        label: '微信状态'
      },
      {
        value: 'info.INVITESTATUS',
        label: '邀约状态'
      },
      {
        value: 'info.REPORTSHOPID',
        label: '邀约进店'
      },
      /*      {
              value: 'more',
              label: '高级搜索'
            }*/
    ],
  },
}

const getters = {
  companyPlugin: state => {
    return state.companyPlugin
  },
  RoleIconList: state => {
    return state.RoleIconList
  },
  condition: state => {
    return state.condition
  },
  sexImg: state => {
    return state.sexImg
  },
  moreOption: state => {
    return state.moreOption
  }
}

const mutations = {}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/dictionaries/dictionaries.js